module.exports = __webpack_public_path__ + "img/dg-nav-below-nav-hyundai.6a7ecdc3.png";